import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

import type { GrConfirmModalData, GrConfirmTone } from './confirm-modal.types';

@Component({
  selector: 'gr-confirm-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: block;' },
  template: `
    <div class="gr-confirm">
      @if (icon) {
        <span class="gr-confirm__icon" [attr.data-tone]="iconTone" aria-hidden="true">
          <span class="material-icons-outlined" aria-hidden="true">{{ icon }}</span>
        </span>
      }
      <div class="gr-confirm__body">
        @if (message) {
          <p class="gr-confirm__message">{{ message }}</p>
        }
        @if (description) {
          <p class="gr-confirm__description">{{ description }}</p>
        }
      </div>
    </div>
  `,
})
export class GrConfirmModalComponent {
  private readonly config = inject(DynamicDialogConfig);

  private readonly data = (this.config.data ?? {}) as GrConfirmModalData;

  protected readonly icon: string | undefined = this.data.icon;
  protected readonly iconTone: GrConfirmTone = this.data.iconTone ?? 'info';
  protected readonly message: string | undefined = this.data.message;
  protected readonly description: string | undefined = this.data.description;
}
